var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper mb-4"},[_c('div',{staticClass:"container-video-crucero ratio ratio-16x9",staticStyle:{"padding-top":"20px"}},[_c('youtube',{ref:"youtube",staticClass:"container-mobile-video",attrs:{"width":"100%","video-id":_vm.videoIdSv,"player-vars":_vm.playerVars},on:{"playing":_vm.playing,"error":_vm.error}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }